import clsx from 'clsx'
import { NavLink, matchPath, matchRoutes, useLocation } from 'react-router-dom'

interface NavBarLinkProps {
  path: string
  name: string
  activePaths?: string[]
  onClick?(): void
}

const NavBarLink: React.FC<NavBarLinkProps> = ({
  onClick,
  path,
  activePaths,
  name,
}) => {
  activePaths = activePaths || [path]
  const location = useLocation()
  const isActive = activePaths.some(p =>
    matchPath(
      {
        path: p,
        end: false,
      },
      location.pathname
    )
  )
  let to = path

  if (path === '/discover') {
    to = '/discover/all-offers?offerStatuses=PartiallyTaken,NotTaken'
  }

  return (
    <NavLink
      onClick={onClick}
      key={path}
      to={to}
      className={navData =>
        clsx(
          'font-semibold transition-colors duration-300 md:border-b md:text-title1 text-title2',
          isActive
            ? 'text-primary border-primary'
            : 'text-main border-transparent hover:text-main-accent'
        )
      }
    >
      {name}
    </NavLink>
  )
}

export default NavBarLink
